import React, { useEffect, useState } from 'react'
import { TextField } from '@mui/material'

import CustomTextField from './CustomTextField'

const DebouncedInput = ({ value: initialValue, onChange, debounce = 500, outlined = false, ...props }) => {
  // States
  const [value, setValue] = useState(initialValue)

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value)
    }, debounce)

    return () => clearTimeout(timeout)
  }, [value])

  const InputComponent = outlined ? TextField : CustomTextField

  return <InputComponent {...props} value={value} onChange={e => setValue(e.target.value)} />
}

export default DebouncedInput
